/**
 * Better Auth's client, fetched by the first sign-in, sign-out or consent that asks for it. No
 * screen draws with it, and imported directly it rode in every screen's first load.
 */
export const authClient = () =>
  import("@/client/lib/better-auth-client").then((module) => module.client);
